import React from 'react';
import SEO from '../components/SEO';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Thesis from '../components/Thesis';
import Ventures from '../components/Ventures';
import Consulting from '../components/Consulting';
import About from '../components/About';
import Footer from '../components/Footer';
import BottomNav from '../components/BottomNav';

const Home = () => {
  return (
    <div className="min-h-screen bg-slate-50" data-testid="home-page">
      <SEO 
        title="OwlWorkLabs | UK Venture Studio Building Intelligent Systems"
        description="OwlWorkLabs is a UK-based venture studio that identifies meaningful problems and builds scalable products at the intersection of technology, sustainability, and community."
        canonical="https://www.owlworklabs.com"
      />
      <Header />
      <Hero />
      <Thesis />
      <Ventures />
      <Consulting />
      <About />
      <Footer />
      <BottomNav />
    </div>
  );
};

export default Home;